var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStocksGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34ZM21 14C20.1716 14 19.5 14.6716 19.5 15.5C19.5 16.3284 20.1716 17 21 17H23.6943L20.2789 20.9034L17.2312 18.3315C16.5995 17.7983 15.6554 17.8768 15.1204 18.507L10.8565 23.5292C10.3204 24.1607 10.3977 25.1073 11.0292 25.6435C11.6607 26.1796 12.6073 26.1023 13.1435 25.4708L16.4394 21.5887L19.4701 24.1464C20.0952 24.6739 21.0277 24.6033 21.5664 23.9878L25.5 19.4922V21.5C25.5 22.3284 26.1716 23 27 23C27.8284 23 28.5 22.3284 28.5 21.5V15.5C28.5 14.6716 27.8284 14 27 14H21Z",
    fill: "white"
  })));
}

export default SvgStocksGlyph;